module.exports = __webpack_public_path__ + "media/success.cda24e90.wav";